import { useMemo } from "react";
import { EditorContentType } from "./editorInterface";
import { useWorkspaceData } from "./useWorkspaceData";

const useEditorContent = (workspaceIdParam?: string) => {
  const {
    data: workspaceData,
    isLoading,
    isPending,
    error,
    refetch,
  } = useWorkspaceData(workspaceIdParam);

  const data = useMemo<EditorContentType | null | undefined>(() => {
    if (!workspaceData) return workspaceData as undefined;
    return workspaceData.content || null;
  }, [workspaceData]);

  return { data, isLoading, isPending, error, refetch };
};

export default useEditorContent;
